module.exports = __webpack_public_path__ + "static/media/Humidifiersbanner.17d8889b.jpg";